import axios from "axios";
import {store} from "@store";
import {handleLogout} from "@store/actions/auth";
import WebPaths from "@router/paths/web";
import PanelPaths from "@router/paths/panel";
import {ErrorCodes} from "@utils/types/errorCodes";
import Notify from "@components/noty/notify";

/**
 * Handles errors returned from API calls and displays appropriate notifications.
 *
 * @param {object} error - The error object returned by the API call.
 * @param {object} [error.response] - The response object of the error.
 * @param {number} error.response.status - The HTTP status code of the error.
 * @param {object} [error.response.data] - The data object of the error.
 * @param {string} [error.message] - The error message string.
 */
const handleError = (error) => {
    const {response: {status, data} = {}, message} = error;

    let delayDebounceFn;

    if (axios.isCancel(error)) {
        console.warn("Request canceled:", message);
        return;
    }

    switch (status) {
        case 401: {
            store.dispatch(handleLogout());
            break;
        }
        case 500:
            Notify("error", "top-left", "خطای سرور");
        /*delayDebounceFn = setTimeout(() => {
            window.location.assign(WebPaths.errors["500"]);
        }, 500);

        return () => clearTimeout(delayDebounceFn);*/
        case 422:
            Object.values(data?.errors || []).flat().forEach((errorMessage) => {
                Notify("error", "top-left", errorMessage);
            });
            break;
        case 406:
            Notify("error", "top-left", data?.message);
            break;
        case 403:
            Notify("error", "top-left", data?.message);
            delayDebounceFn = setTimeout(() => {
                window.location.assign(WebPaths.errors["403"]);
            }, 500);

            return () => clearTimeout(delayDebounceFn);
        case 404:
            Notify("error", "top-left", data?.message);
            delayDebounceFn = setTimeout(() => {
                window.location.assign(WebPaths.errors["404"]);
            }, 500);

            return () => clearTimeout(delayDebounceFn);
        default:
            Notify("error", "top-left", message || "خطایی رخ داده");
            if (message) console.error(message);
            break;
    }

    switch (error.response?.data?.code) {
        case ErrorCodes.redirectToHome: {
            delayDebounceFn = setTimeout(() => {
                window.location.assign(WebPaths.home);
            }, 500);

            return () => clearTimeout(delayDebounceFn);
        }
        case ErrorCodes.redirectToOrders: {
            delayDebounceFn = setTimeout(() => {
                window.location.assign(PanelPaths.orders);
            }, 500);

            return () => clearTimeout(delayDebounceFn);
        }
        case ErrorCodes.redirectToProductionManagement: {
            delayDebounceFn = setTimeout(() => {
                window.location.assign(PanelPaths.admin.productionManagement);
            }, 500);

            return () => clearTimeout(delayDebounceFn);
        }
        default:
            break;
    }
};

export default handleError;
